import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {
  createDealerPriceList,
  deleteDealerPriceList,
  getDealerPriceListById,
  getDealerPriceListList,
  updateDealerPriceList,
} from '../../services/DealerPriceListService'

interface GetDealerPriceListListParams {
  pageNumber: number
  pageSize: number
  filterkey: any
}

interface DealerPriceListState {
  DealerPriceListList: any
  dealerPriceList: any
}

const initialState: DealerPriceListState = {
  DealerPriceListList: null,
  dealerPriceList: null,
}

// Fetch Dealer Price List list
export const getDealerPriceListListApi = createAsyncThunk(
  'dealerPriceList/getDealerPriceListList',
  async ({pageNumber, pageSize, filterkey}: GetDealerPriceListListParams, {rejectWithValue}) => {
    try {
      const result = await getDealerPriceListList(pageNumber, pageSize, filterkey)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Fetch Dealer Price List by ID
export const getDealerPriceListByIdApi = createAsyncThunk(
  'dealerPriceList/getDealerPriceListById',
  async (id: any, {rejectWithValue}) => {
    try {
      const result = await getDealerPriceListById(id)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Create a new Dealer Price List
export const createDealerPriceListApi = createAsyncThunk(
  'dealerPriceList/createDealerPriceList',
  async (payload: any, {rejectWithValue}) => {
    try {
      const result = await createDealerPriceList(payload)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Update Dealer Price List
export const updateDealerPriceListApi = createAsyncThunk(
  'dealerPriceList/updateDealerPriceList',
  async ({id, payload}: {id: any; payload: any}, {rejectWithValue}) => {
    try {
      const result = await updateDealerPriceList(id, payload)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Delete Dealer Price List
export const deleteDealerPriceListApi = createAsyncThunk(
  'dealerPriceList/deleteDealerPriceList',
  async (id: any, {rejectWithValue}) => {
    try {
      const result = await deleteDealerPriceList(id)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

const DealerPriceListSlice = createSlice({
  name: 'dealerPriceList',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getDealerPriceListListApi.fulfilled, (state, action) => {
        state.DealerPriceListList = action.payload
      })
      .addCase(getDealerPriceListByIdApi.fulfilled, (state, action) => {
        state.dealerPriceList = action.payload
      })
      .addCase(createDealerPriceListApi.fulfilled, (state, action) => {
        state.dealerPriceList = action.payload
      })
      .addCase(updateDealerPriceListApi.fulfilled, (state, action) => {
        state.dealerPriceList = action.payload
      })
      .addCase(deleteDealerPriceListApi.fulfilled, (state, action) => {
        state.dealerPriceList = null
      })
  },
})

export default DealerPriceListSlice

